import { createActionTypes } from 'utils/action/actionTypes';

export const GET_CHARGER_LOG_GRAPH = createActionTypes('GET_CHARGER_LOG_GRAPH');
